'use client';

import { useEffect } from 'react';

/**
 * Root level Error Boundary for Next.js App Router.
 * Handles uncaught client-side or server-side component errors.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log to the internal browser console
    console.error('[GLOBAL ERROR]: An unexpected application error occurred.');
  }, [error]);

  return (
    <html>
      <body className="bg-white dark:bg-zinc-950 flex flex-col justify-center items-center min-h-screen text-center p-6">
        <h1 className="text-3xl font-bold text-zinc-900 dark:text-white mb-4">
          Something went wrong
        </h1>
        <p className="text-zinc-600 dark:text-zinc-400 mb-6 max-w-md">
          A server-side or unexpected application error occurred. We've been notified and are looking into it.
        </p>
        <button
          onClick={() => reset()}
          className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
        >
          Try Again
        </button>
      </body>
    </html>
  );
}
